import axios from './axios';

export default {
  get: async query => {
    const params = { params: query };
    const { data } = await axios.get(`tags`, params);
    return data;
  }
};
